import React, { Fragment, useEffect } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get, isNil } from 'lodash';
import { Check } from 'lucide-react';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';

import style from './style.scss';

const ThankYou = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const applicationId = useSelector(state => get(state, 'workflow.entityId', get(state, 'workflow.attributes.entityId', '')));
  const data = useSelector(state => get(state, 'workflow.data.data') || get(state, 'workflow.state.data'));

  useEffect(() => {
    if (!key) {
      navigate('/dashboard');
    } else if (isNil(data)) {
      navigate(`/applications/fsl/checkin?key=${key}`);
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className={cn('use-tailwind grid-container fluid', style['thanks-page'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="cell small-12 medium-12" style={{ textAlign: 'left' }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}

              <Column className="small-12 large-8 large-offset-2 space-y-6 mt-6">
                <div className="bg-green-100 rounded-full p-4 md:p-6 w-16 h-16 md:w-24 md:h-24 mx-auto flex items-center justify-center">
                  <Check className="w-12 h-12 text-green-600" strokeWidth={3} />
                </div>
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 text-center">Thank you!</h1>
              </Column>

              <Column className="small-12 large-8 large-offset-2">
                <div className="bg-green-50 rounded-lg p-6 mt-6 text-left">
                  <h2 className="text-lg md:text-xl font-semibold text-green-800 mb-4">What happens next?</h2>

                  <div className="space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 bg-green-100 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-green-800 font-medium text-sm md:text-base">
                        1
                      </div>
                      <p className="text-sm md:text-lg text-green-800">Our team will review your bank statements</p>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 bg-green-100 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-green-800 font-medium text-sm md:text-base">
                        2
                      </div>
                      <p className="text-sm md:text-lg text-green-800">
                        If we need any additional information, we'll reach out to you directly
                      </p>
                    </div>
                  </div>
                </div>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ThankYou;
